var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.entryLink)?_c('p',{staticClass:"text-box"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_c('div',[_c('div',{staticClass:"text-box skeleton-text skeleton"}),_c('div',{staticClass:"text-box skeleton-text skeleton"})])
}
var staticRenderFns = []

export { render, staticRenderFns }